import { useCallback, useState } from "react";

import { apiFetch } from "~/lib/fetchClient";

const useLeadAvatar = (leadId) => {
  const [uploading, setUploading] = useState(false);
  const [removing, setRemoving] = useState(false);

  const updateAvatar = useCallback(
    async (file) => {
      const formData = new FormData();
      formData.append("lead[photo_url]", file);

      setUploading(true);
      try {
        await apiFetch.put(`/leads/${leadId}`, { body: formData });
        GlobalContainer.notify("Headshot updated successfully.", "success");
        return true;
      } catch {
        GlobalContainer.notify(
          "Couldn't update the headshot, check if file size is greater than 10MB",
          "danger",
        );
        return false;
      } finally {
        setUploading(false);
      }
    },
    [leadId],
  );

  const removeAvatar = useCallback(async () => {
    setRemoving(true);
    try {
      await apiFetch.put(`/leads/${leadId}`, {
        json: { lead: { remove_photo_url: true } },
      });
      GlobalContainer.notify("Headshot removed successfully.", "success");
      return true;
    } catch {
      GlobalContainer.notify(
        "Couldn't remove the headshot, please try again",
        "danger",
      );
      return false;
    } finally {
      setRemoving(false);
    }
  }, [leadId]);

  return { updateAvatar, removeAvatar, uploading, removing };
};

export default useLeadAvatar;
